import styled from "styled-components";
import { Text } from "../common/text/text";

export const Terms = styled(Text)`
  font-size: 0.8rem;
`;

export const Container = styled.div`
  width: 400px;
  background-color: #eee;
  height: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  padding: 1rem;
  border-radius: 0.5rem;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  a {
    color: ${({ theme }) => theme.colors?.primaryBlue?.main};
  }
`;
